const state = {
  roleList: [],
  userListSize: 0,
  allowedUsers: 0
}

const getters = {
  roleList: state => state.roleList
}

const mutations = {
  commit_usersAdminAllStates (state, obj) {
    state.roleList = obj['roleList']
    state.userListSize = obj['userListSize']
    state.allowedUsers = obj['allowedUsers']
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/usersAdmin.js